export const orange = {
    30: "#FFF1E5",
    40: "#FFB980",
    50: "#FFA861",
    60: "#FF943D",
    70: "#F37916",
    80: "#D66000",
    90: "#A34900",
    100: "#703200",
};
